// AUTH REDUCERS

export const SIGN_IN_GOOGLE = 'SIGN_IN_GOOGLE';
export const LOAD_USER = 'LOAD_USER';
export const LOG_OUT = 'LOG_OUT';
export const AUTH_ALERTS = 'AUTH_ALERTS';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

// USER REDUCERS

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_HOME_USER_LOADING = 'SET_HOME_USER_LOADING';
export const FETCH_HOME_USERS = 'FETCH_HOME_USERS';
export const CLEAR_USERS_STATE = 'CLEAR_USERS_STATE';
export const FETCH_HOME_POSTS = 'FETCH_HOME_POSTS';
export const SET_HOME_POST_LOADING = 'SET_HOME_POST_LOADING';

// File Uploads

export const FILE_UPLOADED = 'FILE_UPLOADED';
export const FILE_UPLOAD_LOADING = 'FILE_UPLOAD_LOADING';
export const NEW_FILE_UPLOAD = 'NEW_FILE_UPLOAD';
